<template>
    <div>
        <Table :no-data-text="$t('common.noData')" class="table-css" :columns="columns" :data="tableCloudTrailListData" height="500" :loading="cloudTrailListLoadings" style="width: 100.1%;"></Table>
    </div>
</template>
<script>
    import TableExpand from '../cloudTrail_list/TableExpand.vue';
    var tableCloudTrailListVue = {};
    export default {
        name: 'TableCloudTrailList',
        components: { TableExpand },
        data () {
            return {
                cloudTrailListLoadings: false,
                accountIdSearchKey:'',
                regionSearchKey:'',
                eventNameSearchKey:'',
                agentDate:'',
                columns: [
                    {
                        type: 'expand',
                        width: 50,
                        render: (h, params) => {
                            return h(TableExpand, {
                                props: {
                                    row: params.row
                                }
                            })
                        }
                    },
                    {
                        title: this.$t('CloudTrailSecurity.caseTime'),
                        key: 'eventTime',
                    },
                    {
                        title: this.$t('CloudTrailSecurity.userName'),
                        key: 'userName'
                    },
                    {
                        title: this.$t('CloudTrailSecurity.caseName'),
                        key: 'eventName'
                    },
                    {
                        title: this.$t('CloudTrailSecurity.resourceType'),
                        key: 'resourceType'
                    },
                    {
                        title: this.$t('CloudTrailSecurity.resourceName'),
                        key: 'resourceName'
                    }
                ],
                tableCloudTrailListData:[]
            }
        },
        beforeCreate: function() {
            tableCloudTrailListVue = this
        },
        methods:{
            showAll: function(accountIdSearchKey,regionSearchKey,eventNameSearchKey,agentDate){
                tableCloudTrailListVue.accountIdSearchKey = accountIdSearchKey;
                tableCloudTrailListVue.regionSearchKey = regionSearchKey;
                tableCloudTrailListVue.eventNameSearchKey = eventNameSearchKey;
                tableCloudTrailListVue.agentDate = agentDate;
                tableCloudTrailListVue.getSecurityData();
            },
            // 显示数据
            /****************************************************/
            getSecurityData:function() {
                this.cloudTrailListLoadings = true;
                this.$api.cloudTrail.listCloudTrailEvent({
                    "accountId" : tableCloudTrailListVue.accountIdSearchKey,
                    "regionStr" : tableCloudTrailListVue.regionSearchKey,
                    "eventNames" : tableCloudTrailListVue.eventNameSearchKey,
                    "timeList" : tableCloudTrailListVue.agentDate   
                })
                .then(res => {
                    this.tableCloudTrailListData = res.data;
                    for(var i=0;i<this.tableCloudTrailListData.length;i++){
                        if(this.tableCloudTrailListData[i].cloudTrailReferencedResources!=undefined){
                            // 资源名称
                            this.tableCloudTrailListData[i].resourceName=this.tableCloudTrailListData[i].cloudTrailReferencedResources[0].resourceName;
                            // 资源类型
                            this.tableCloudTrailListData[i].resourceType=this.tableCloudTrailListData[i].cloudTrailReferencedResources[0].resourceType;
                        }
                    }
                    this.cloudTrailListLoadings = false;
                });
            }
        }
    }
</script>
<style scoped>
    .ivu-page
    {
        margin-top: 10px !important;
        margin-bottom: 30px !important;
    }
    /* 滚动条 */
    .table-css >>> .ivu-table-overflowY::-webkit-scrollbar {
        width: 10px;
        height: 10px;
    }
    .table-css >>> .ivu-table-overflowY::-webkit-scrollbar-thumb {
        border-radius: 5px;
        background: #ccc;
    }
    .table-css >>> .ivu-table-overflowY::-webkit-scrollbar-track {
        background: #eeeeef;
    }
    .table-css >>> .ivu-table-overflowY::-webkit-scrollbar-corner {
        background-color: #eeeeef;
    }
    .table-css >>> .ivu-table-overflowX{
        overflow-x: hidden !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/monitor/logs/cloudTrail/cloudTrail_list/TableCloudTrailList.vue